import { render, staticRenderFns } from "./WEBSEARCH.vue?vue&type=template&id=276a7ac4"
import script from "./WEBSEARCH.vue?vue&type=script&lang=js"
export * from "./WEBSEARCH.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports